import React from "react";
import { ChangeRequestTableRow } from "../types";
import { RequestTypeIconWithHoverTip } from "../ChangesTable";
import { normaliseIdColumnValue } from "../helpers";
import { RequestBox } from "src/components/FeedContainer";
import { useChangesNavigation } from "../hooks";

export const ChangeBox = ({ row }: { row: ChangeRequestTableRow }) => {
  const { handleOnClick } = useChangesNavigation(row);
  const primaryIcon = React.useMemo(() => {
    return (
      <RequestTypeIconWithHoverTip
        requestType={row.requestType}
        serviceType={row.serviceType}
        channel={row.requestChannel}
      />
    );
  }, [row.requestType, row.serviceType, row.requestChannel]);

  const secondaryText = React.useMemo(
    () =>
      normaliseIdColumnValue(
        row.id,
        row.journeyId,
        row.distributorApplicationId
      ),
    [row.id, row.journeyId, row.distributorApplicationId]
  );

  return (
    <RequestBox
      primaryIcon={primaryIcon}
      primaryText={row.address}
      secondaryText={secondaryText}
      summaryText={row.statusText}
      onClick={handleOnClick}
      data-id={`changeBox.${row.id}`}
    />
  );
};
